import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { NavLink, Switch, Route, Redirect, withRouter } from 'react-router-dom';
import { FormattedMessage, defineMessages } from 'react-intl';

import './styles.css';
import PageTitle from '../../components/PageTitle';
import Header from '../../components/Header';
import Menu from '../../components/Menu';
import ChangeProfilePage from '../ChangeProfilePage';

const messages = defineMessages({
  'change-profile': {
    id: 'settings.menu.accountInfo',
    defaultMessage: 'Account Information',
  },
});

class IntersectSettingsPage extends React.PureComponent {
  static propTypes = {
    current: PropTypes.shape({
      viewer: PropTypes.shape({
        isNaviance: PropTypes.bool,
      }).isRequired,
    }).isRequired,
    match: PropTypes.shape({
      path: PropTypes.string,
    }).isRequired,
  };

  render() {
    const { match, current } = this.props;
    const { isNaviance } = current.viewer;

    return (
      <div styleName="container">
        <PageTitle title="Settings" category="Intersect" />
        <div styleName="pageContainer">
          <Menu as="ul" vertical className="third">
            {!isNaviance && (
              <Menu.Item as="li">
                <NavLink
                  to={`${match.path}/change-profile`}
                  className="menu-link"
                  activeClassName="active"
                >
                  <FormattedMessage {...messages['change-profile']} />
                </NavLink>
              </Menu.Item>
            )}
          </Menu>
          <div styleName="pageContent">
            <Header as="h1" styleName="settingsHeader">
              <FormattedMessage id="settings.header" defaultMessage="Settings" />
            </Header>
            <Switch>
              {!isNaviance && (
                <Route
                  path={`${match.path}/change-profile`}
                  component={ChangeProfilePage}
                />
              )}
              <Redirect from="*" to={`${match.path}/change-profile`} />
            </Switch>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  current: state.current,
});
const reduxContainer = connect(mapStateToProps, {})(withRouter(IntersectSettingsPage));

export default reduxContainer;
